import React, { useContext } from 'react';
import Typed from 'react-typed';
import DefaultContainer from '../DefaultContainer';
import { AppContext } from '../Context';

export default function () {
  const { intro } = useContext(AppContext);
  return (
    <section className="intro-container">
      <DefaultContainer style={{ marginTop: '100px' }}>
        <div className="d-flex flex-column flex-lg-row justify-content-between mt-5 pt-3">
          <div className="d-flex flex-column justify-content-center align-items-center text-center text-lg-left">
            <h1 className="h1 align-self-start font-weight-bold text-white font-mono">
              { intro.header }
            </h1>
            <div className="my-4 intro-text2 mr-5 text-white font-mono">
              { intro.desc }
            </div>
            <a
                target="_blank" rel="noopener noreferrer" href="https://api.payportal.org/"
                className="btn btn-primary intro-button text-lg font-weight-bold align-self-start font-mono">
              { intro.cta }
            </a>
          </div>
          <div className="developer-typed">
            <div className="developer-typed-header py-1 text-center font-mono">
              www.payportal.org/payment.js
            </div>
            <div className="developer-typed-body pt-2 font-mono">
              <span className="mx-2 font-weight-bold"> > </span>
              <Typed
                className="font-mono"
                strings={['Automate your payments using PayPortal APIs']}
                typeSpeed={40}
                backSpeed={50}
                loop
              />
              <br />
            </div>
          </div>
        </div>
      </DefaultContainer>
    </section>
  );
}
